"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyUse = void 0;
var PropertyUse;
(function (PropertyUse) {
    PropertyUse["PRIMARY_RESIDENCE"] = "PRI";
    PropertyUse["SECONDARY_RESIDENCE"] = "2ND";
    PropertyUse["INVESTMENT_PROPERTY"] = "INV";
    PropertyUse["UNKNOWN"] = "UNK";
})(PropertyUse = exports.PropertyUse || (exports.PropertyUse = {}));
